import { ErrorBase } from "@util/errors";

export class BalanceAccountUserNotFoundError extends ErrorBase {}
export class BalanceAccountNotFoundError extends ErrorBase {}
export class InvalidFileFormatError extends ErrorBase {}
export class CreateBalanceTransactionError extends ErrorBase {}
export class UpdateBalanceAccountError extends ErrorBase {}
export class UpdateBalanceBudgetError extends ErrorBase {}
